import { render, staticRenderFns } from "./SpecificationsAndInventory.vue?vue&type=template&id=5b71ed5a&scoped=true"
import script from "./SpecificationsAndInventory.vue?vue&type=script&lang=js"
export * from "./SpecificationsAndInventory.vue?vue&type=script&lang=js"
import style0 from "./SpecificationsAndInventory.vue?vue&type=style&index=0&id=5b71ed5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b71ed5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b71ed5a')) {
      api.createRecord('5b71ed5a', component.options)
    } else {
      api.reload('5b71ed5a', component.options)
    }
    module.hot.accept("./SpecificationsAndInventory.vue?vue&type=template&id=5b71ed5a&scoped=true", function () {
      api.rerender('5b71ed5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/creatStore2/steps/SpecificationsAndInventory.vue"
export default component.exports